import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { ROUTES, USER_TYPE } from "../constants";
import {SessionService} from "./session.service";

@Injectable( {
	providedIn: "root"
} )

export class BuyerRoleGuardService {

	constructor(
		private sessionService: SessionService,
		private router: Router
	) { }

	/**
	 * It will restrict route activation for user other than buyer type.
	 * Return true if authenticated otherwise false.
	 */
	canActivate( route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		const allowedUserRole = route.data.allowedRole;
		if ( this.sessionService.isAuthenticated() ) {
			if ( this.sessionService.userType === allowedUserRole ) {
				return true;
			} else if ( this.sessionService.userType === USER_TYPE.SUPPLIER ) {
				this.router.navigate( [ ROUTES.SUPPLIER_ROUTE + "/" + ROUTES.OVERVIEW ] );
				return false;
			}
			return false;
		}
		
		if (state.url) {
			const returnUrl = encodeURIComponent(state.url);
			this.router.navigateByUrl(`${ROUTES.LOG_IN}&returnUrl=${returnUrl}`);
			return true;
		}
		this.router.navigate( [ ROUTES.LOG_IN ] );
		return false;
	}
}
